import { useTranslation } from 'react-i18next'
import OnboardingLayout from '../../components/OnboardingLayout'
import LanguagePicker from '../../components/profile/LanguagePicker'
import MaterialIcon from '../../components/ui/MaterialIcon'
import { KILO } from '../../constants/KILO_THEME'
import type { AppLanguage } from '../../i18n/languages'
import { ONBOARDING_STEP_COUNT } from '../../lib/onboarding'

type StepWelcomeProps = {
  onNext: () => void
  language: AppLanguage
  onLanguageChange: (language: AppLanguage) => void | Promise<unknown>
}

const StepWelcome = ({ onNext, language, onLanguageChange }: StepWelcomeProps) => {
  const { t } = useTranslation()

  return (
    <OnboardingLayout
      step={0}
      totalSteps={ONBOARDING_STEP_COUNT}
      onNext={onNext}
      nextButtonText={t('onboarding.welcome.letsBegin')}
    >
      <div className="flex flex-col items-center gap-6 py-4 text-center">
        <div className="w-full">
          <p className={`mb-2 text-[10px] font-mono uppercase tracking-wider ${KILO.text.soft}`}>{t('auth.language')}</p>
          <LanguagePicker compact value={language} onChange={(next) => void onLanguageChange(next)} />
        </div>
        <p className={KILO.meta}>{t('onboarding.welcome.intake')}</p>
        <h2 className={`text-xl ${KILO.heading}`}>{t('onboarding.welcome.title')}</h2>
        <div className={`flex h-24 w-24 items-center justify-center rounded-2xl border border-kilo-border ${KILO.bg.nested} ring-1 ring-kilo-accent/20`}>
          <MaterialIcon name="sports_martial_arts" filled size="xl" />
        </div>
        <p className={`text-base leading-relaxed ${KILO.text.muted}`}>{t('onboarding.welcome.body')}</p>
      </div>
    </OnboardingLayout>
  )
}

export default StepWelcome
